import axios from 'axios';
import { FileUploadResponse } from './api.types';
import { authService } from 'services/auth/auth_service';

const BASE_API_URL = process.env.REACT_APP_URL_API ?? '';
const API_URL = BASE_API_URL + '/files';
const eseiafToken = authService.getTokenAPIInterna();

/**
 * @param
 * @param
 * @returns
 */

export interface FileEntity {
  uuid: string;
  originalName?: string;
  mimeType?: string;
  size?: number;
  // ...outros campos que seu FilesFileEntity expõe
}

export const uploadFile = async (
  type: string,
  file: File,
): Promise<FileUploadResponse> => {
  const formData = new FormData();
  formData.append('type', type);
  formData.append('file', file);

  const response = await axios.post<FileUploadResponse>(API_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
      Authorization: `Bearer ${eseiafToken}`,
    },
  });

  return response.data;
};

export const getFileByUUID = async (uuid: string) => {
  const token = authService.getTokenAPIInterna();
  const response = await axios.get(`${API_URL}/${uuid}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const downloadFileByUUID = async (uuid: string) => {
  const token = authService.getTokenAPIInterna();
  const response = await axios.get(`${API_URL}/${uuid}/download`, {
    responseType: 'blob',
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const viewFileByUUID = async (uuid: string) => {
  const token = authService.getTokenAPIInterna();
  const response = await axios.get(`${API_URL}/view/${uuid}`, {
    responseType: 'blob',
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
